import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({ name: 'extractDomain' })
@Injectable()
export class ExtractDomainPipe implements PipeTransform {
  transform(url: string): string {
    if (url && url.length) {
      const arr = url.split('/');
      return arr[2].replace('www.', '');
    }
    return url;
  }
}
